import React, { useState, useRef } from 'react';
import { Placeholder } from 'rsuite';
import 'rsuite/dist/rsuite.min.css';

const PlaceholderTable = () => {
  const [isColoumLoading, setIsColoumLoading] = useState(false);
  const scrollContainerRef = useRef(null);

  const handleScroll = () => {
    const container = scrollContainerRef.current;
    if (!container) return;

    const nearBottom = container.scrollHeight - container.scrollTop - container.clientHeight < 100;
    const nearRight = container.scrollWidth - container.scrollLeft - container.clientWidth < 100;

    if ((nearBottom || nearRight) && !isColoumLoading) {
      setIsColoumLoading(true);

      setTimeout(() => {
        setIsColoumLoading(false);
        // You can append more data here if needed
      }, 1500);
    }
  };

  const totalDataCols = 18;
  const totalStickyCols = 2;

  return (
    <div className='company_table_list etf_holding_table'>
      <div
        className='table-responsive'
        style={{ maxHeight: '400px', overflow: 'auto' }}
        ref={scrollContainerRef}
        onScroll={handleScroll}
      >
        <table className='table table_fixed_column'>
          <thead>
            <tr>
              <th className='sticky-col left-col-1' style={{ textAlign: 'center' }}>Symbol</th>
              <th className='sticky-col left-col-2'>Company Name</th>
              {Array.from({ length: totalDataCols }).map((_, i) => (
                <th key={i} style={{ textAlign: 'right' }}>10/{(i % 3) + 1}/2024</th>
              ))}
              {isColoumLoading && (
                <th style={{ minWidth: 120 }}>Loading...</th> // Optional extra column header
              )}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 30 }).map((_, rowIndex) => (
              <tr key={rowIndex} className={rowIndex % 2 === 0 ? "table_tr_odd" : ""}>
                <td className='sticky-col left-col-1' style={{ textAlign: 'center' }}>DFAX</td>
                <td className='sticky-col left-col-2'>Mercedes-Benz Group</td>
                {Array.from({ length: totalDataCols }).map((_, colIndex) => (
                  <td key={colIndex} style={{ textAlign: 'right' }}>
                    {colIndex % 3 === 1 ? <span className='date_null'>Null</span> : '18133253'}
                  </td>
                ))}
                {isColoumLoading && (
                  <td>
                    <Placeholder.Paragraph rows={1} style={{ margin: 0 }} />
                  </td>
                )}
              </tr>
            ))}

            {isColoumLoading && (
              <tr>
                <td colSpan={totalStickyCols + totalDataCols + 1}>
                  <Placeholder.Grid rows={3} columns={10} active />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PlaceholderTable;
